import Generator from "./Generator";

function App() {
  return ( 
    <Generator/>
  );
}

export default App;